<template>
    <div class="images">
        <span
            v-if="!activeImage"
            class="icon"
        >
            <i class="fa fa-image"></i>
        </span>
        <div
            v-else
            class="image-con"
        >
            <img :src="$srcOverwrite(activeImage)"/>
            <div class="btn-con">
                <div
                    v-show="canGoBack"
                    class="bubble-button"
                    @click="moveIndex($event, -1)"
                >
                    <i class="fa fa-angle-left"></i>
                </div>
                <div
                    v-show="canGoForward"
                    class="bubble-button"
                    @click="moveIndex($event, 1)"
                >
                    <i class="fa fa-angle-right"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name : "ImagesDisplay",
    props : {
        value : {
            type : String,
            required : false,
        },
    },
    data () {
        return {
            parsedValues : [],
            activeIndex : 0,
        };
    },
    beforeMount () {
        if(this.value) {
            this.parsedValues = JSON.parse(this.value);
        }
    },
    computed : {
        activeImage () {
            return this.parsedValues[this.activeIndex];
        },
        canGoBack () {
            return this.activeIndex > 0;
        },
        canGoForward () {
            return this.activeIndex < this.parsedValues.length - 1;
        },
    },
    methods : {
        moveIndex ($event, mod) {
            $event.stopPropagation();
            this.activeIndex += mod;
        }
    },
}
</script>

<style lang="scss" scoped>
    @import '../../../../assets/css/_theme';
    .fa {
        font-size:18px;
        color: #d1d1d1;
    }
    .image-con {
        height: 40px;
        display:inline-block;
        position:relative;
        img {
            height:100%;
            max-width: 80px;
            width: auto;
            display:block;
        }
        .btn-con {
            display:none;
            & > .bubble-button {
                position:absolute;
                top:0;
                margin-top:44%;
                cursor:pointer;
                height:24px;
                width:24px;
                border-radius:100px;
                background-color:$white-bis;
                border:1px solid $grey-lighter;
                text-align:center;
                font-size:16px;
                .fa {
                    color:$black;
                }

                &:first-child {
                    left:-12px;
                }
                &:last-child {
                    right:-24px;
                }
            }
        }
    }
    .images:hover {
        .btn-con {
            display:block;
        }
    }
</style>
